import AUTHOR from '../../data/author'
import { getRelation, mapRelations } from '../relation'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

export const mapAuthors = mapRelations(AUTHOR)

export const getAuthor = getRelation(AUTHOR)
